import { render, staticRenderFns } from "./ShareIntentItem.vue?vue&type=template&id=4d6355a2&"
import script from "./ShareIntentItem.vue?vue&type=script&lang=js&"
export * from "./ShareIntentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports